module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/twitter_home.cd9debcf.jpg";